import clx from "classnames";
import { FC, HTMLAttributes } from "react";
import { Headline } from "src/UI";
import st from "./Switch.module.scss";

interface ISwitchProps extends HTMLAttributes<HTMLDivElement> {
	title?: string;
	isInline?: boolean;
	outline?: boolean;
	variant?: "blue" | "green";
	disable?: boolean;
	value: boolean;
	onSwitch?: () => void;
};

const Switch: FC<ISwitchProps> = ( props ) => {

	const { id = "switch", title, className, isInline = false, outline = false, variant = "blue", disable = false, value = false, onSwitch } = props;

	const classes = clx(st.formGroup, className, st[variant], { 
		[st.inLine]: isInline,
		[st.disabled]: disable,
		[st.outline]: outline
	});

	return (
		<div className={classes}>
			{ !!title && <Headline>{ title }</Headline> }
			<input type="checkbox" id={id} className={st.input} checked={value} onChange={() => !!onSwitch && onSwitch() } />
			<label htmlFor={id} title={title} />
		</div>
	);
};

export default Switch;
